<form [formGroup]="changeEmailForm" (ngSubmit)="onSubmitChangeEmailForm()" class="wrapper-account-page">
  <span class="title-settings-page">
    {{'ACCOUNT.change_email_address' | translate}}
  </span>
  <span class="subtitle-settings-page">
    {{'ACCOUNT.changing_email_address_can_be_performed_once_every' | translate}} 90 {{'OTHERS.days' | translate}}.
  </span>
  <span class="subtitle-settings-page">
    {{'ACCOUNT.the_update_will_take_effect_immediately' | translate}}
  </span>
  <div class="wrapper-input" [ngClass]="{'error': changeEmailForm.controls['email'] | formControlErrorMessages: 'Please enter a valid email address.': formTriedToSubmit}">
    <span class="label-input">
      {{'ACCOUNT.new_email_address' | translate}}
    </span>
    <div class="custom-input">
      <input type="email" formControlName="email" [placeholder]="'ACCOUNT.enter_new_email_address' | translate">
    </div>
    <div *ngIf="changeEmailForm.controls['email'] | formControlErrorMessages: 'Please enter a valid email address.': formTriedToSubmit" class="wrapper-error-message">
      <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
      <span>{{changeEmailForm.controls['email'] | formControlErrorMessages: 'Please enter a valid email address.': formTriedToSubmit}}</span>
    </div>
  </div>
  <div class="wrapper-submit-settings">
    <button type="submit" class="custom-btn custom-btn--primary">
      <span> {{'NEW_TEXT.save_changes' | translate}}</span>
      <tl-spinner *ngIf="isSpinnerActive"></tl-spinner>
    </button>
  </div>
</form>
